export function companiesActive(id, name, index, segment, labelId) {
  return {
    type: 'SET_COMPANIES_ACTIVE',
    id,
    name,
    index, 
    segment,
    labelId
  };
}

export function companiesSet(
  user,
  companies,
  profile,
  keycloakId,
  systemType,
  configs,
  operationalUsers,
  userMaster,
  labelOnlyRestaurants,
  userInfos
) {
  return {
    type: 'SET_COMPANIES',
    user,
    configs,
    companies,
    profile,
    keycloakId,
    systemType,
    operationalUsers,
    userMaster,
    labelOnlyRestaurants,
    userInfos
  };
}

export function companyFirstSelect(firstSelectRestaurant) {
  return {
    type: 'SET_FIRST_RESTAURANT',
    firstSelectRestaurant
  };
}

export function updateCountConfig(configs) {
  return {
    type: 'UPDATE_COUNT_CONFIG',
    configs
  };
}
